// @flow
import superagentInterface from "redux-query-interface-superagent"

export const makeRequest = superagentInterface
